module.exports = __webpack_public_path__ + "img/duel_perilous.fa274fed.png";